export function isFAQEmpty(props) {
    return !props?.sections?.length;
}
